<template>
    <div class="app-contriner">
        <!--form 组件-->
        <eForm ref="form" :is-add="isAdd" :sup-this="supThis" />

        <el-row :gutter="15">
          <!--角色管理-->
          <el-col :xs="24" :sm="24" :md="15" :lg="13" :xl="17">
            <el-card class="box-card" shadow="never">
              <div slot="header" class="clearfix">
                <span class="role-span">角色列表</span>
                <div id="opt" style="float: right">
                  <el-radio-group v-model="opt" size="mini">
                    <el-radio-button label="权限分配"/>
                    <el-radio-button label="角色人员"/>
                  </el-radio-group>
                </div>
              </div>
              <dynamic-search
                  :data="tableFilterList(tableHead)"
                  @search="dataTableSearch">
                  <template v-slot:next>
                      <el-button class="btnbg" icon="el-icon-plus" @click="subAdd">新增</el-button>
                  </template>
              </dynamic-search>
              <edit-data-table
                :loading="loading"
                :head="tableHead"
                height
                :data="list"
                :total="total"
                :offset="offset"
                :page="page"
                highlight-current-row
                @handlePageChange="dataTablePageChange"
                @handleSizeChange="dataTableSizeChange"
                ref="table"
                :showNumber="true"
                @current-change="handleCurrentChange">
                <template v-slot:toolbar="{row}">
                    <el-button size="mini" type="text" icon="el-icon-edit" @click="edit(row)"/>
                    <el-popover :ref="row.id" placement="top" width="180">
                        <p>确定删除本条数据吗？</p>
                        <div style="text-align: right; margin: 0">
                            <el-button size="mini" type="text" @click="$refs[row.id].doClose()">取消</el-button>
                            <el-button :loading="delLoading" type="primary" size="mini" @click="subDelete(row.id)">确定</el-button>
                        </div>
                        <el-button slot="reference" type="text" icon="el-icon-delete" class="table-del-btn" size="mini"/>
                    </el-popover>
                </template>
                <template v-slot:enabled="{row}">
                  <el-tag :type="row.enabled ? '' : 'info'">{{ row.enabled ? '启用' : '禁用'}}</el-tag>
                </template>
              </edit-data-table>
            </el-card>
          </el-col>
          <!-- 授权 -->
          <el-col :xs="24" :sm="24" :md="9" :lg="11" :xl="7">
            <el-card v-show="opt === '权限分配'" class="box-card" shadow="never">
              <div slot="header" class="clearfix">
                <el-tooltip class="item" effect="dark" content="选择指定角色分配权限" placement="top">
                  <span class="role-span">权限分配</span>
                </el-tooltip>
                <el-button
                  :disabled="!showButton"
                  :loading="permissionLoading"
                  icon="el-icon-check"
                  size="mini"
                  style="float: right; padding: 6px 9px"
                  type="primary"
                  @click="savePermission">保存</el-button>
              </div>
              <tree
              ref="permission"
              keyField="id"
              :data="permissions"
              :prop="treeProps"
              :checkbox="true"
              :default-checked-keys="permissionIds"/>
            </el-card>
            <el-card v-show="opt === '角色人员'" class="box-card" shadow="never">
              <div slot="header" class="clearfix">
                <el-tooltip class="item" effect="dark" content="选择指定角色分配人员" placement="top">
                  <span class="role-span">角色人员</span>
                </el-tooltip>
              </div>
              <role-users ref="roleUsers" :dicts="dicts"></role-users>
            </el-card>
          </el-col>
        </el-row>
    </div>
</template>

<script>
    import Tree from '@/components/Tree/index.vue'
    import '@/components/EditDataTable';
    import DataTableMixin from '@/mixins/DataTableMixin';
    import DynamicSearch from '@/components/DynamicSearch/index.vue'
    import initDict from '@/mixin/initDict'
    import { del, getRolePerms, editPermission } from '@/api/role'
    import { getPermissionTree } from '@/api/permission'
    import eForm from './form'
    import { deepClone } from '@/utils/index'
    import RoleUsers from './users'
    export default {
        name: "Role",
        mixins: [DataTableMixin, initDict],
        components: {
            Tree,
            DynamicSearch,
            eForm,
            RoleUsers
        },
        data() {
            return {
                delLoading: false,
                supThis: this,
                isAdd: false,
                tableHead: [
                    {
                        label: '角色名称',
                        prop: 'name',
                        query: {
                            type: 'input'
                        },
                        align: 'left'
                    },{
                        label: '角色编码',
                        prop: 'code'
                    },
                    {
                        label: '是否启用',
                        prop: 'enabled',
                        type: 'slot',
                        width: 100,
                    },
                    {
                        label: '创建时间',
                        prop: 'created',
                        sortable: true
                    },
                ],
                treeProps: {
                    children: 'children',
                    label: 'name'
                },
                permissionLoading: false, showButton: false, opt: '权限分配',
                permissions: [], permissionIds: [], roleId: ''
            }
        },
        created() {
            this.$nextTick(() => {
                this.getPermissions()
                this.dataTableInit()
            })
        },
        methods: {
          dataTableBeforeInit() {
                this._url = '/role'
                const query = this._query
                const params = { page: this.page, size: this.offset }
                this._params = Object.assign(params,query)
                return true
            },
            handleDeletes(rows) {
                rows.forEach(element => {
                    this.subDelete(element.id)
                });
            },
            subDelete(id) {
                this.delLoading = true
                del(id).then(res => {
                    this.delLoading = false
                    this.$refs[id].doClose()
                    this.dleTableChangePage()
                    this.dataTableInit()
                    this.$notify({
                        title: '删除成功',
                        type: 'success',
                        duration: 2500
                    })
                }).catch(err => {
                    this.delLoading = false
                    this.$refs[id].doClose()
                    console.log(err)
                })
            },
            subAdd() {
              this.$refs.form.dialog = true;
              this.$refs.form.form = {enabled: true};
              this.isAdd = true
            },
            edit(data) {
                this.isAdd = false
                const _this = this.$refs.form
                _this.form = deepClone(data)
                _this.dialog = true
            },
            handleCurrentChange(val) {
              if (val) {
                // 清空权限与菜单的选中
                this.$refs.permission.$refs.tree.setCheckedKeys([])
                // 保存当前的角色id
                this.roleId = val.id
                // 点击后显示按钮
                this.showButton = true
                // 初始化
                this.userIds = []
                this.permissionIds = []

                // 权限数据需要特殊处理
                this.getRolePermissions().then(res => {
                const premsIds = []
                  res.forEach(item => {
                    let add = true
                    res.forEach(data => {
                      if (item.id === data.parentId) {
                        add = false
                        return
                      }
                    })
                    if (add) {
                      premsIds.push(item.id)
                    }
                  })
                  this.permissionIds = premsIds
                })
                // 角色对应的用户
               this.$refs.roleUsers.roleId = val.id
               this.$refs.roleUsers.dataTableInit()
              }
            },
            getPermissions() {
                getPermissionTree({enabled: 1}).then(res => {
                  this.permissions =  res.data || []
                }).catch(err => {
                  console.log(err.response)
                })
            },
            async getRolePermissions() {
              let data = []
              await getRolePerms({id: this.roleId}).then(res => {
                 data = res.data || []
              }).catch(err => {
                console.log(err)
              })
              return Promise.resolve(data)
            },
            savePermission() {
              this.permissionLoading = true
              const role = { id: this.roleId, permissions: [] }

              // 获取半选Key
              this.$refs.permission.$refs.tree.getHalfCheckedKeys().forEach(function(data, index) {
                role.permissions.push(data)
              })

              // 获取全选Key
              this.$refs.permission.$refs.tree.getCheckedKeys().forEach(function(data, index) {
                role.permissions.push(data)
              })
              editPermission(role).then(res => {
                this.$notify({
                  title: '保存成功',
                  type: 'success',
                  duration: 2500
                })
                this.permissionLoading = false
              }).catch(err => {
                this.permissionLoading = false
                console.log(err)
              })
            }
        }
    }
</script>

<style scoped lang="scss">
    .app-contriner{
      padding: 20px;
    }
    .data-tree-box,
    .data-table-box {
        padding: 15px;
    }
</style>
